// extracted by mini-css-extract-plugin
module.exports = {"barcodeSvg":"Barcode_barcodeSvg__xnR1J"};